<template>
  <v-container>
    <details-header>
      <template class="text-center">
        <div class="text-center">
          <h1 class="d-block">
            This survey has already been completed
          </h1>
          <v-img
            class="mx-auto my-6"
            src="https://res.cloudinary.com/dlw64o4rf/image/upload/v1604329288/web%20images/cc-survey-complete_ieh7kh.svg"
            width="400"
          ></v-img>
        </div>
      </template>
    </details-header>
  </v-container>
</template>

<script>
import DetailsHeader from "@/components/common/DetailsHeader";
export default {
  name: "SurveyAlreadyComplete",
  components: {
    "details-header": DetailsHeader
  }
};
</script>
